import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionsCreators from "actions/agent";
import PageBox from "../public/index";
// import {Link} from 'react-router-dom'
import { Row, Col, Breadcrumb, Form, Input, Button } from "antd";

// import { HomeOutlined } from "@ant-design/icons";
class HotNews extends Component {
  formRef = React.createRef();
  constructor() {
    super();
    this.onFinish = this.onFinish.bind(this);
    this.state = {
      time: 0
    };
  }
  onFinish(values) {
    let send = { ...values,f_type:1};
    let time = 3;
    let t = setInterval(() => {
      if (time <= 0) {
        clearInterval(t);
        this.formRef.current.resetFields();
      }
      this.setState({ time: time-- });
    }, 1000);
    send['f_type']='培训申请';
    this.props.apply(send);
  }

  componentDidMount(){
    this.props.getFormContent({sign:'competition'})
  }

  render() {
    let {formContent}=this.props.index;
    return (
      <PageBox>
        <Breadcrumb style={{ paddingTop: 20 }}>
          <Breadcrumb.Item>
            <a href="/">首页</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            赛事举办申请
          </Breadcrumb.Item>
        </Breadcrumb>
            <div className="main jiameng">
            {formContent?
                <div className="formIntro" dangerouslySetInnerHTML={{__html:formContent.fc_content}}></div>
                :null}
              <div className="applyTitle">
                请完整填写申请表单，我们将第一时间和您联系。
              </div>
              <Form
                name="cpapply"
                layout="vertical"
                ref={this.formRef}
                onFinish={this.onFinish}
              >
                <Form.Item
                  name="f_name"
                  rules={[
                    {
                      required: true,
                      message: "申请人不能为空"
                    }
                  ]}
                >
                  <Input placeholder="请输入申请人" autoComplete="off" />
                </Form.Item>
                <Form.Item
                  name="f_phone"
                  rules={[
                    {
                      required: true,
                      message: "联系电话不能为空"
                    }
                  ]}
                >
                  <Input placeholder="请输入联系电话" autoComplete="off" />
                </Form.Item>
                <Form.Item
                  name="f_type"
                  rules={[
                    {
                      required: true,
                      message: "赛事主题不能为空"
                    }
                  ]}
                >
                  <Input placeholder="请输入赛事主题" autoComplete="off" />
                </Form.Item>
                <Form.Item
                  name="f_desp"
                >
                  <Input.TextArea placeholder="申请理由" autoComplete="off" rows={4} />
                </Form.Item>
                <Form.Item>
                <Button
                      type="primary"
                      block
                      htmlType="submit"
                      disabled={this.state.time ? true : false}
                    >
                      提交{this.state.time ? this.state.time : null}
                    </Button>
                </Form.Item>
              </Form>
            </div>
      </PageBox>
    );
  }
}

export default connect(
  state => state,
  dispatch => bindActionCreators(actionsCreators, dispatch)
)(HotNews);
